module.exports = __webpack_public_path__ + "img/keypal-plus-line.092d6356.png";